import { useCallback, useEffect, useState } from 'react';
import {
  beginGoogleAdminLogin,
  getCurrentAdmin,
  logoutAdmin,
} from '../services/adminAuthService';

export const useAdminAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const checkSession = useCallback(async () => {
    setLoading(true);
    const result = await getCurrentAdmin();
    if (result.ok) {
      setUser(result.data);
      setError('');
    } else {
      setUser(null);
      if (result.status !== 401) setError(result.error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const startLogin = useCallback(() => {
    const result = beginGoogleAdminLogin();
    if (!result.ok) setError(result.error);
  }, []);

  const signOut = useCallback(async () => {
    const result = await logoutAdmin();
    if (result.ok) {
      setUser(null);
      setError('');
    } else {
      setError(result.error);
    }
  }, []);

  return { user, loading, error, startLogin, signOut };
};
